import React from "react";
import { AuthProvider, Descope } from "@descope/react-sdk";
import { useAuth } from "./AuthContext";

function Login() {
  const { login } = useAuth();

  const handleSuccess = async (e) => {
    try {
      const sessionToken = e.detail.sessionJwt;
      await login(sessionToken);
    } catch (err) {
      console.error("Login failed:", err);
      alert("Login failed. Check backend logs.");
    }
  };

  return (
    <div className="page">
      <div className="card">
        <AuthProvider projectId="P38kkUb5TQkLbggTSld9xM1VQ8SG">
          <Descope
            flowId="sign-in"
            theme="light"
            onSuccess={handleSuccess}
            onError={(err) => {
              console.error("Descope error:", err);
            }}
          />
        </AuthProvider>
      </div>
    </div>
  );
}

export default Login;
